import React from "react"
import { DatePicker, Icon } from "antd"
import { DatePicker as DatePickerMobile, List } from "antd-mobile"
import "antd/lib/date-picker/style/css"
import moment from "moment"
import Util from "../../util/util"
import FloorList from "./components/FloorList"
import mapBoxUtil from "../../util/mapBox"
import DataBuilding from "../../data/building"
import Shop from "../Shop"
import "./index.less"

const DATEPICKER_LOCAL = {
  lang: {
    placeholder: "Select date",
    rangePlaceholder: ["Start date", "End date"],
    today: "Today",
    now: "当前时间",
    backToToday: "Back to today",
    ok: "确定",
    clear: "Clear",
    month: "Month",
    year: "Year",
    timeSelect: "选择时间",
    dateSelect: "选择日期",
    monthSelect: "Choose a month",
    yearSelect: "Choose a year",
    decadeSelect: "Choose a decade",
    yearFormat: "YYYY",
    dateFormat: "M/D/YYYY",
    dayFormat: "D",
    dateTimeFormat: "M/D/YYYY HH:mm:ss",
    monthFormat: "MMMM",
    monthBeforeYear: true,
    previousMonth: "Previous month (PageUp)",
    nextMonth: "Next month (PageDown)",
    previousYear: "Last year (Control + left)",
    nextYear: "Next year (Control + right)",
    previousDecade: "Last decade",
    nextDecade: "Next decade",
    previousCentury: "Last century",
    nextCentury: "Next century",
  },
  timePickerLocale: {
    placeholder: "Select time",
  },
}

// import 'util/moment/locale/zh-cn';
moment.locale("zh-cn")

const TIME_REFRESH = 10
const TIME_COUNTDOWN = 60

class Building extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      features: [],
      pitchClicked: false,
      marketId: 1,
      time: moment(),
      // storeId: 1025,
      // storeName: "montblanc",
    }
    this.marketId = 1
    this.floor = null
    this.getFloorList(this.marketId)
    this.closeStorePanel = this.closeStorePanel.bind(this)
    this.changeTime = this.changeTime.bind(this)
  }

  /**
   * 根据商场id获取楼层列表
   * @param marketId
   */
  getFloorList(marketId) {
    if (!marketId) {
      return
    }
    DataBuilding.getFloorList(marketId)
      .then(list => {
        list.sort((a, b) => {
          return b.floor - a.floor
        })
        // this.changeFloor(1)
        let current = list[7]
        this.changeFloor(current)
        this.setState({
          list,
        })
      })
      .catch(function(error) {
        // TODO
      })
  }

  /**
   * 切换楼层
   * @param floor
   */
  changeFloor = floor => {
    if (floor === this.floor) {
      return
    }
    this.setState({})
    this.floor = floor
    DataBuilding.floorFeatures(this.marketId, floor.floor)
      .then(res => {
        let map = this.map
        if (!map) {
          map = this.map = mapBoxUtil.init(res.data, floor.floor)
          map.on("load", () => {
            this.refresh(TIME_REFRESH)
          })
        } else {
          mapBoxUtil.renderMap(map, floor.floor)
          this.refresh(TIME_REFRESH)
        }
      })
      .catch(err => {
        // TODO
      })
  }

  /**
   * 获取热点数据
   * @param map
   * @param floor
   */
  getFloorData(map, floor, selectedTime) {
    let me = this
    let heatParam = { floor: floor.floor }
    if (selectedTime) {
      let sTime = selectedTime.format("YYYY-MM-DD HH:mm:ss")
      let ds = sTime.split(" ")
      heatParam.date = ds[0]
      heatParam.time = ds[1]
    }
    DataBuilding.floorHot(heatParam).then(res => {
      mapBoxUtil.renderHeat(map, res.data)
    })
    DataBuilding.getVistorCount(this.marketId, floor.floor).then(res => {
      let data = res.data
      this.setState({
        totalCount: data.total,
        floorCount: data.detail[floor.name] || 0,
      })
    })
    map.on("click", function(e) {
      var features = map.queryRenderedFeatures(e.point, {
        layers: ["buildings"],
      })
      if (features.length) {
        if (!features[0].properties.id) {
          //过滤柱子
          return
        }
        // if (shopClickEventCtr) {
        //   return;
        // }
        // shopClickEventCtr = true;
        let clicked = features[0]
        me.setState({
          storeId: clicked.properties.id,
          storeName: clicked.properties.name,
        })
        me.clearTimer()
      }
    })
  }

  /**
   * 执行刷新
   * @param time
   */
  refresh(time) {
    this.clearTimer()
    if (!this.state.storeId) {
      this.getFloorData(this.map, this.floor)
      this.setState({ time: moment() })
    }

    this.timer = setTimeout(() => {
      this.refresh(time)
    }, time * 1000)
  }

  /**
   * 清除定时器
   */
  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }

  /**
   * 关闭店铺面板
   */
  closeStorePanel() {
    let me = this
    if (me.selectedTime) {
      // me.getFloorData (me.map, me.floor, me.selectedTime)
      me.state.countDown = TIME_COUNTDOWN
      me.countDown()
    } else {
      this.refresh(TIME_REFRESH)
    }
    this.setState({ storeId: null, storeName: null })
  }

  componentWillUnmount() {
    this.clearTimer()
  }

  /**
   * 3D切换
   */
  togglePitch() {
    let map = this.map
    let clicked = this.state.pitchClicked
    if (!clicked) {
      map.setPitch(45)
      this.setState({ pitchClicked: true })
    } else {
      map.setPitch(0)
      this.setState({ pitchClicked: false })
    }
  }

  /**
   * 选择时间
   * @param value
   * @param str
   */
  changeTime(value, str) {
    //TODO
    let me = this
    me.selectedTime = value
    if (str) {
      // onchange
      // me.setState ({ time: value })
      me.setState({})
    } else {
      // onok
      me.setState({ countDown: TIME_COUNTDOWN, time: value })
      me.getFloorData(me.map, me.floor, me.selectedTime)
      me.clearTimer()
      me.countDown()
    }
  }

  changeTimeMobile(date, index) {
    let me = this
    if (index >= 0) {
      //change
      let time = moment(
        `${date[0]}-${parseInt(date[1]) + 1}-${date[2]} ${date[3]}:${date[4]}`,
        "YYYY-MM-DD HH:mm"
      )
      me.selectedTime = time
    } else {
      me.selectedTime = moment(date)
      me.setState({ countDown: TIME_COUNTDOWN, time: me.selectedTime })
      me.getFloorData(me.map, me.floor, me.selectedTime)
      me.clearTimer()
      me.countDown()
    }
  }

  onCancelDate() {
    this.selectedTime = null
    this.setState({})
  }

  /**
   * 倒计时
   */
  countDown() {
    let me = this
    me.timer = setTimeout(() => {
      let countDown = me.state.countDown
      if (countDown >= 1) {
        me.setState({ countDown: countDown - 1 })
        me.countDown()
      } else {
        me.selectedTime = null
        me.refresh(TIME_REFRESH)
      }
    }, 1000)
  }

  render() {
    let {
      pitchClicked,
      list,
      totalCount,
      floorCount,
      storeId,
      storeName,
      time,
      countDown,
    } = this.state
    let datePicker = null
    let timeMoment = this.selectedTime || time
    let { onCloseModal } = this.props
    if (0 && Util.isMobile) {
      datePicker = (
        <DatePickerMobile
          value={new Date(timeMoment.format("YYYY/MM/DD HH:mm:ss"))}
          onValueChange={(date, index) => {
            this.changeTimeMobile(date, index)
          }}
          onChange={date => {
            this.changeTimeMobile(date)
          }}
          onDismiss={() => {
            this.onCancelDate()
          }}
        >
          <List.Item arrow="horizontal">
            {time.format("YYYY-MM-DD HH:mm:ss")}
          </List.Item>
        </DatePickerMobile>
      )
    } else {
      datePicker = (
        <DatePicker
          showTime
          format="YYYY-MM-DD HH:mm:ss"
          locale={DATEPICKER_LOCAL}
          value={timeMoment}
          placeholder="Select Time"
          onChange={this.changeTime}
          onOk={this.changeTime}
          onBlur={() => {
            this.onCancelDate()
          }}
        />
      )
    }
    return (
      <div className="page page-building">
        <div className="page-inner">
          <div className="header">
            <Icon type="left" onClick={onCloseModal} />
            <div>正大百货</div>
          </div>
          <div className="content">
            <div className="timeLineBg">
              <span className="laydateClass mbsc-comp">{datePicker}</span>
              {countDown ? (
                <span className="floorInfo">{countDown}秒后切回实时视图</span>
              ) : (
                <span className="floorInfo">
                  本楼：{totalCount}；本层：{floorCount}
                </span>
              )}
            </div>
            <div
              className={"pitchBtn" + (pitchClicked ? " clicked" : "")}
              onClick={() => {
                this.togglePitch()
              }}
            >
              3D
            </div>
            <FloorList
              list={list}
              current={this.floor}
              onChangeFloor={floor => {
                this.changeFloor(floor)
              }}
            />
            <div id="map" />
          </div>
        </div>
        {storeId && this.floor ? (
          <Shop
            floor={this.floor.floor}
            date={moment(this.selectedTime || time).format("YYYY-MM-DD")}
            id={storeId}
            name={storeName}
            onCloseModal={this.closeStorePanel}
          />
        ) : null}
      </div>
    )
  }
}

export default Building
